import { useState } from 'react'
import Button from '@talkdesk/cobalt-react-button'
// eslint-disable-next-line import-x/no-named-as-default
import Icon from '@talkdesk/cobalt-react-icon'
import Input from '@talkdesk/cobalt-react-input'
import InputGroup, { Item } from '@talkdesk/cobalt-react-input-group'
import Label from '@talkdesk/cobalt-react-label'
import styles from './PasswordInputFieldGroup.module.css'
import { useTheme } from '@talkdesk/cobalt-react-theme-provider'
import Box from '@talkdesk/cobalt-react-box'

const PasswordInputFieldGroup = ({
  label,
  disabledForm = false,
  placeholder,
  password,
  onPasswordChange,
  autoFocus = false,
  onFocus,
  onBlur,
}) => {
  const [showPassword, setShowPassword] = useState(false)
  const theme = useTheme()
  const handleShowPassword = () => setShowPassword((prev) => !prev)

  return (
    <Box>
      <Box paddingY='2'>
        <Label>{label}</Label>
      </Box>
      <InputGroup disabled={disabledForm}>
        <Item>
          <Input
            value={password}
            onChange={onPasswordChange}
            type={showPassword ? 'text' : 'password'}
            variation='unstyled'
            placeholder={placeholder}
            onFocus={onFocus}
            onBlur={onBlur}
            autoFocus={autoFocus}
          />
        </Item>
        <Item noHover width='min' backgroundColor={theme.gray300}>
          <Button
            htmlType='button'
            type='secondary'
            shape='compact'
            onClick={handleShowPassword}
            tabIndex='-1'
            className={styles['password-input-show-button']}
          >
            <Icon
              name={showPassword ? 'visibility_off' : 'visibility'}
              size='tiny'
            />
          </Button>
        </Item>
      </InputGroup>
    </Box>
  )
}

export default PasswordInputFieldGroup
